<template>
    <div class="real-learn-time" v-show="showLearnTime">
        <div class="learn-time-module">
            <Icon class="i-rate-close" type="ios-close" @click="closeLearnTimeModal"/>
            <section class="i-rate-content">
                <span class="i-rate-title">您本次课程观看时长为 {{learnTime}}</span>
                <div class="hide-module show-module">
                    <div class="rate-btn" @click="closeLearnTimeModal">确认</div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RealLearnTime',
        props: {
            showLearnTime: {
                type: Boolean,
                default: false,
            }, learnTime: {
                type: String,
                default: '0',
            },
        },
        methods: {
            closeLearnTimeModal() {
                this.$emit('closeLearnTimeModal')
            }
        },
    }
</script>

<style lang="scss">
    .real-learn-time {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.6);

        .learn-time-module {
            background-color: #fff;
            box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            position: relative;
            min-width: 360px;

            .i-rate-close {
                position: absolute;
                left: 5px;
                top: 5px;
                font-size: 34px;
                cursor: pointer;
            }

            .i-rate-title {
                height: 44px;
                line-height: 44px;
                display: block;
                text-align: center;
                font-size: 17px;
                color: #000;
            }

            .i-rate-content {
                padding: 20px 24px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .rate-module {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;

                    .ivu-rate-star-chart {
                        font-size: 28px;
                        color: #ed6c00;
                    }

                    .ivu-rate-star-zero {
                        i {
                            //color: #ed6c00;
                        }
                    }

                    .ivu-rate-star-full {
                        i {
                            color: #ed6c00;
                        }
                    }

                    .ivu-rate-star {
                        margin: 0 5px;
                    }

                    .ivu-rate-star-full:before {
                        color: #ed6c00;
                        font-size: 28px;
                    }

                    .ivu-rate-star:before {
                        font-size: 28px;
                    }
                }

                .rate-info {
                    display: block;
                    text-align: center;
                    font-size: 14px;
                    color: #4a4a4a;
                }

                .rate-orange {
                    color: #ed6c00;
                }

                .hide-module {
                    transition: all 0.3s;
                    height: 0;
                    overflow: hidden;
                    opacity: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    .rate-input {
                        width: 240px;

                        textarea {
                            border-radius: 3px;
                            background-color: rgba(248, 248, 248, 0.82);
                            border: solid 0.5px rgba(0, 0, 0, 0.1);
                            resize: none;
                        }

                        textarea:focus {
                            box-shadow: none;
                        }
                    }

                    .rate-btn {
                        width: 240px;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 16px;
                        background-color: #ed6c00;
                        margin: 15px 0 20px 0;
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                        font-size: 14px;
                    }
                }

                .show-module {
                    height: 70px;
                    opacity: 1;
                }
            }
        }
    }
</style>
